/**
 * Recent Searches Utility
 * Shared localStorage helpers for recent and trending searches.
 */

const RECENT_SEARCHES_KEY = "rituality_recent_searches"
const MAX_RECENT = 5

export const TRENDING_SEARCHES = [
  "Full Moon Ritual",
  "Morning Meditation",
  "Tarot Reading",
  "Healing",
  "Chakra Balancing",
]

export function getRecentSearches(): string[] {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY)
    if (!stored) return []
    const parsed = JSON.parse(stored)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((s): s is string => typeof s === "string").slice(0, MAX_RECENT)
  } catch {
    return []
  }
}

export function saveRecentSearch(query: string) {
  try {
    const truncated = query.slice(0, 200)
    const recent = getRecentSearches().filter(s => s !== truncated)
    recent.unshift(truncated)
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)))
  } catch {
    // localStorage unavailable or full -- degrade gracefully
  }
}

export function clearRecentSearches() {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY)
  } catch {
    // localStorage unavailable -- degrade gracefully
  }
}
